import { Injectable } from '@angular/core';
import { FeatureGuard } from '../../features-data/guards/feature.guard';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { BannerCanvasTypesEnum } from '../../features-data/features-data.data';
import { Toggles } from '../../features-data/sub-models/toggles.model';
import { FeaturesDataStore } from '../../features-data/features-data.store';
import { NavigationService } from '../../navigation/navigation.service';
import { DialogService } from '../../dialog/dialog.service';

@Injectable()
export class XeroPermissionGuard extends FeatureGuard implements CanActivate {
  constructor(
    featuresDataStore: FeaturesDataStore,
    navigationService: NavigationService,
    dialogService: DialogService
  ) {
    super(featuresDataStore, navigationService, dialogService);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return super.checkFeatureAccess(
      Toggles.KEYS.XERO,
      '/',
      BannerCanvasTypesEnum.feature_lock,
      true
    );
  }
}
